export const GreenwoodDrawing = (props: React.SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={401}
        height={146}
        fill="none"
        {...props}
    >
        <path
            fill="#fff"
            d="M364.623 145.115h-329V.82h329v144.295Zm-257.813-4.616h29.343v-35.787H106.81v35.787Zm34.815 0h36.137v-35.787h-36.137v35.787Zm41.607 0h33.573v-35.787h-33.573v35.787Zm39.043 0h36.137v-35.787h-36.137v35.787Zm41.609 0h30.797v-35.787h-30.797v35.787ZM106.81 100.096h187.871V45.84H106.81v54.256Zm0-58.872h29.343V5.437H106.81v35.787Zm34.815 0h36.137V5.437h-36.137v35.787Zm41.607 0h33.573V5.437h-33.573v35.787Zm39.043 0h36.137V5.437h-36.137v35.787Zm41.609 0h30.797V5.437h-30.797v35.787Z"
        />
        {props.children}
    </svg>
)
